import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const DEFAULT_DATA = {
  title: "Ready to Experience WarmWellness Care?",
  subtitle: "Our team is here to guide you to the right services for your health needs",
  primaryButton: {
    text: "Contact Us",
    link: "/contact",
    bgColor: "#FFFFFF",
    textColor: "#0760ad"
  },
  secondaryButton: {
    text: "Book Appointment",
    link: "/appointment",
    bgColor: "transparent",
    textColor: "#FFFFFF",
    borderColor: "#FFFFFF"
  },
  backgroundColor: "#0760ad"
};

const ServicesCTA = () => {
  const [ctaData, setCtaData] = useState(DEFAULT_DATA);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCtaData = async () => {
      try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/services/cta/`);
        if (response.ok) {
          const data = await response.json();
          setCtaData(data);
        }
      } catch (error) {
        console.error('Error fetching services CTA data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCtaData();
  }, []);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-48" style={{ backgroundColor: DEFAULT_DATA.backgroundColor }}>
        <span className="loading loading-spinner loading-lg text-white"></span>
      </div>
    );
  }

  return (
    <div className="py-20 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: ctaData.backgroundColor || DEFAULT_DATA.backgroundColor }}>
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl font-bold text-white mb-6">
            {ctaData.title || DEFAULT_DATA.title}
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            {ctaData.subtitle || DEFAULT_DATA.subtitle}
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <motion.a
              href={ctaData.primaryButton?.link || DEFAULT_DATA.primaryButton.link}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-3 rounded-full font-medium shadow-lg"
              style={{ 
                backgroundColor: ctaData.primaryButton?.bgColor || DEFAULT_DATA.primaryButton.bgColor,
                color: ctaData.primaryButton?.textColor || DEFAULT_DATA.primaryButton.textColor
              }}
            >
              {ctaData.primaryButton?.text || DEFAULT_DATA.primaryButton.text}
            </motion.a>
            <motion.a
              href={ctaData.secondaryButton?.link || DEFAULT_DATA.secondaryButton.link}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-3 rounded-full font-medium shadow-lg border-2"
              style={{ 
                backgroundColor: ctaData.secondaryButton?.bgColor || DEFAULT_DATA.secondaryButton.bgColor,
                color: ctaData.secondaryButton?.textColor || DEFAULT_DATA.secondaryButton.textColor,
                borderColor: ctaData.secondaryButton?.borderColor || DEFAULT_DATA.secondaryButton.borderColor
              }}
            >
              {ctaData.secondaryButton?.text || DEFAULT_DATA.secondaryButton.text}
            </motion.a>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ServicesCTA;